import { Grid, Button, TextField } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import { Form as FormikForm, useFormikContext } from "formik";

import { CustomField } from '../../../inputs/CustomField';

export const CreateAccount = ({ onClose }) => {

    const { isSubmitting } = useFormikContext();

    return (
        <FormikForm>
            <Grid container spacing={2} >

                <Grid item xs={12} sm={12} md={6}>
                    <CustomField label="Cuenta contable" name="account_code" fullWidth as={TextField} />
                </Grid>

                <Grid item xs={12} sm={12} md={6}>
                    <CustomField label="Nombre de la cuenta" name="account_name" fullWidth as={TextField} />
                </Grid>

                <Grid item xs={12} sm={12} md={6}>
                    <CustomField label="Secuencia" name="account_sequence" type="number" fullWidth as={TextField} />
                </Grid>

            </Grid>

            <Grid item sm={12} textAlign={"right"} mt={3}>

                <Button
                    variant="outlined"
                    onClick={() => onClose()}
                >
                    cancelar
                </Button>

                <Button sx={{ marginLeft: 2 }}
                    variant="contained"
                    type="submit"
                >
                    {isSubmitting && <CircularProgress size={"15px"} sx={{ color: "white", marginRight: "6px" }} />}
                    {isSubmitting ? 'Guardando' : 'Guardar'}
                </Button>

            </Grid>

        </FormikForm>
    );
}

export default CreateAccount;